var _path, _path2, _path3, _path4, _g, _g2, _path5, _g3, _path6, _g4, _path7, _path8, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroccoli(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "m420.5 265.8-.3.3c-11.1 13.8-20.7 27-29.2 39.5l.1.1c10.9 6.6 25 7 36.5-.4 8.8-5.6 14.2-14.5 15.6-24l.1-.3c-9-2.3-17-7.9-22.8-15.2z",
    fill: "#3b601c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    d: "m325.8 244.4-23.4 50.3c-18.2 8.9-41.8-1.5-49.8-13.3l-3.6-20.3c5.3.8 10.7 1.2 16.2 1.2 21.9.1 42.6-6.4 60.6-17.9z",
    fill: "#4e7a25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    d: "m180.4 222.5c7.8 8.5 16.3 15.9 25.4 21.9-4.5 30-42.7 45.2-66.1 25.4-5.3-10.3-8.9-17.4-9.1-17.8 12.5-.3 25-4.6 35.6-13.1 5.9-4.8 10.7-10.3 14.2-16.4z",
    fill: "#3b601c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    d: "m81.7 251.7 32.8 63.1-.4.2c-21.6 10-47.2.5-57.2-21.1-6.2-13.5-4.8-28.6 2.3-40.4l.7-2.8c1.3.3 2.7.6 4.1.9 6 1 12 1 17.7.1z",
    fill: "#3b601c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "m66.9 283.9c-4.8-10.5-5.1-22-1.6-32.1-.5-.1-.9-.1-1.4-.2-1.4-.2-2.7-.5-4.1-.9l-.7 2.8c-7.2 11.8-8.5 26.9-2.3 40.4 9.9 21.6 35.5 31.1 57.2 21.1l.5-.2-3.2-6.1c-18.1 2.2-36.3-7.3-44.4-24.8z",
    fill: "#4d841e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    d: "m190.9 232.8c-6.5 23.7-34.7 36.4-56.5 26.4 1.5 2.9 3.3 6.4 5.4 10.5 23.3 19.8 61.5 4.7 66.1-25.4-5.2-3.3-10.2-7.2-15-11.5z",
    fill: "#315112"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    d: "m249 261.5 3.5 19.9c7.9 11.8 31.6 22.2 49.8 13.3l8.9-19.2c-22.6 7.6-50.3-2-62.2-14z",
    fill: "#2c4415"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "m427.6 291.3c-9.1 5.8-19.8 6.8-29.3 3.7-2.5 3.6-5 7.1-7.3 10.6l.1.1c10.9 6.6 25 7 36.5-.4 8.8-5.6 14.2-14.5 15.6-24l.1-.3c-1.5-.4-3-.9-4.4-1.4-2.7 4.6-6.5 8.7-11.3 11.7z",
    fill: "#4d841e"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m331.8 230.4-64.1 136.8-18.7-106.1c-15.4-2.4-30.1-8.1-43.1-16.8l8.1 97.5c.1 22.3-21 28.5-31.5 9.7l-59.5-114.7-41.8 14 113.1 218c6.4 16.3 22.1 27.1 39.8 27.1h46.1c18.7 0 34.7-12.4 40.8-30.1 16.5-47.6 30-96 72-158.3l36.3-52.6z",
    fill: "#cadd78"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#adbc55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m296.7 488.4h-46.1c-17.6 0-33.4-10.8-39.8-27.1l-111.7-215.6-17.4 5.9 112.6 217.2c6.4 16.3 22.1 27.1 39.8 27.1h46.1c9.1 0 18-3 25.3-8.5-2.9.7-5.8 1-8.8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.9 254c-6.3-2.7-12.3-5.9-18-9.6l8.1 97.5c.1 4.4-.9 8.8-2.9 12.7 9.6 2.7 19.5-5 19.5-20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.8 224.5-66 142.9 2.9 16.3c1.2 9.4 5.1 11.2 9.5 9.8 3.7-1.1 6.5-4.1 7.9-7.7l70.6-161.2z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    d: "m88.6 156c-19.3 20.8-21.4 52.7-3.5 75 4.6 5.7 10 10.2 16 13.6-10.8 6.4-23.8 9.2-37.1 6.9-29.7-5-49.7-33.2-44.7-62.9s33.2-49.7 62.9-44.7l1.4-.4c1.2 4.4 2.8 8.5 5 12.5z",
    fill: "#3b601c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    d: "m415 253.6c-13 5.3-27.3 6-40.6 2.3-10.9-3-21.1-9.1-29.3-18-1.5-1.6-2.8-3.2-4.1-4.9l-.2.1c-21.1 18.4-47.3 29.3-75.6 29.3-33.4 0-62.1-15.1-84.7-39.9-3.6 6.1-8.3 11.6-14.1 16.3-19.3 15.5-45.3 17.1-65.2 5.8-6-3.4-11.4-7.9-16-13.6-17.8-22.2-15.8-54.1 3.5-75-2.2-4-3.8-8.1-5-12.4-11.8-44.2 31.8-99.3 90.1-67.6 32.9-88.1 154.6-69.1 181.8-7.6 41.9-20.6 86.8 21.8 71.1 54.9h1.5c34.8 0 63 28.2 63 62.9 0 11.4-3.1 22.2-8.4 31.4 6.6 7 10.7 16.6 10.7 27 0 21.8-17.7 39.5-39.5 39.5-18 0-34.2-14.2-39-30.5z",
    fill: "#4d841e"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    d: "m453.9 244.1c-17.9 0-34.1-14.2-39-30.6-13 5.3-27.3 6-40.6 2.3-10.9-3-21.1-9-29.3-18-1.5-1.6-2.8-3.2-4.1-4.9l-.2.1c-21.1 18.4-47.3 29.3-75.6 29.3-33.4 0-62.1-15.1-84.7-39.9-3.6 6.1-8.3 11.6-14.1 16.3-19.3 15.5-45.3 17.1-65.2 5.8-6-3.4-11.5-7.9-16-13.6-3.8-4.7-6.6-9.8-8.7-15.2-6.7 18.3-4.2 39.2 8.7 55.2 4.6 5.7 10 10.2 16 13.6 19.9 11.2 45.9 9.7 65.2-5.8 5.8-4.7 10.6-10.2 14.1-16.3 22.6 24.7 51.3 39.9 84.7 39.9 28.3 0 54.5-10.9 75.6-29.3l.2-.1c1.3 1.7 2.6 3.3 4.1 4.9 8.2 8.9 18.4 14.9 29.3 18 13.3 3.7 27.6 3 40.6-2.3 4.8 16.4 21 30.6 39 30.6 21.8 0 39.5-17.7 39.5-39.5 0-7.3-2-14.1-5.4-20-6.9 11.7-19.5 19.5-34.1 19.5z",
    fill: "#67a829"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    d: "m85.8 231.8c-.6-.1-1.2-.2-1.8-.3-29.7-5-49.7-33.2-44.7-62.9 1.1-6.6 3.4-12.7 6.5-18.1-13.6 7.8-23.7 21.5-26.5 38.1-5 29.7 15 57.9 44.7 62.9 13.3 2.2 26.3-.5 37.1-6.9-5.7-3.2-10.9-7.5-15.3-12.8z",
    fill: "#4d841e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroccoli);
export default __webpack_public_path__ + "static/media/broccoli.a0d17dbc6a2085f9eb906e6a48809ff4.svg";
export { ForwardRef as ReactComponent };